import { useRequestQuery } from "@/features/common/hooks/useRequestQuery";
import {
  JobFragment,
  JobOrderByWithRelationInput,
  JobWhereInput,
} from "@/generated/graphql-hooks";

const workTimeTypeFilterList: {
  label: string;
  value: keyof Pick<JobFragment, "endAt" | "scale">;
}[] = [
  { label: "按時完成", value: "endAt" },
  { label: "按件完成", value: "scale" },
];

export const WorkTimeTypeFilter = () => {
  const { query, setWhere } = useRequestQuery<
    JobWhereInput,
    JobOrderByWithRelationInput
  >();

  const setWorkTimeTypeFilter = (
    value: keyof Pick<JobFragment, "endAt" | "scale">,
  ) => {
    const { scale, endAt, ...rest } = query?.where;

    setWhere({
      ...rest,
      [value]: {
        not: {
          equals: null,
        },
      },
    });
  };

  return (
    <div className="space-y-4">
      {workTimeTypeFilterList.map(({ label, value }, index) => (
        <label className="flex items-center space-x-3" key={index}>
          <input
            type="radio"
            name="workTimeType"
            value={value}
            checked={value in query?.where}
            className="form-radio text-primary h-4 w-4 rounded-full border-gray-500 bg-transparent !ring-0 !ring-offset-0"
            onChange={() => setWorkTimeTypeFilter(value)}
          />
          <span className="text-base font-light text-gray-900">{label}</span>
        </label>
      ))}
    </div>
  );
};
